import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportOrchestratorService } from './import-process/import-orchestrator.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { FileSanitizerService, EditWorkFileNameHandler, RegistrationValidateTokenService } from './services';
import { RefTablesStorageService } from '@database/workspace';
@NgModule({
	providers: [
		ImportOrchestratorService,
		EditWorkFileNameHandler,
		FileSanitizerService,
		RefTablesStorageService,
		RegistrationValidateTokenService
	],
	declarations: [],
	imports: [CommonModule, FormsModule, ReactiveFormsModule]
})
export class JSONFileImporterModule {}
